//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UpdateTheme } from '@/api/permission/userSetting';
import themeColor from '@/assets/scss/theme.scss';
import themeMinix from "./minix";
export default {
  mixins: [themeMinix],
  name: 'Settings',
  data: function data() {
    return {
      drawer: false,
      themeClass: '',
      imgUrl1: [{
        imgrurl: require('@/assets/images/settings/classic.png'),
        name: '侧边导航',
        layoutType: 'classic'
      }, {
        imgrurl: require('@/assets/images/settings/functional.png'),
        name: '顶部导航',
        layoutType: 'functional'
      }, {
        imgrurl: require('@/assets/images/settings/blend.png'),
        name: '混合导航',
        layoutType: 'blend'
      }, {
        imgrurl: require('@/assets/images/settings/plain.png'),
        name: '简约导航',
        layoutType: 'plain'
      }],
      imgUrl2: [{
        imgrurl: require('@/assets/images/settings/dark.png'),
        name: '暗黑模式',
        className: 'dark'
      }, {
        imgrurl: require('@/assets/images/settings/lightWhite.png'),
        name: '亮白模式',
        className: 'lightWhite'
      }],
      imgUrl3: [{
        name: '经典蓝',
        className: 'blue',
        color: themeColor.blueTheme
      }, {
        name: '玫紫',
        className: 'purple',
        color: themeColor.purpleTheme
      }, {
        name: '湛蓝',
        className: 'azure',
        color: themeColor.azureTheme
      }, {
        name: '海洋',
        className: 'ocean',
        color: themeColor.oceanTheme
      }, {
        name: '生机',
        className: 'green',
        color: themeColor.greenTheme
      }, {
        name: '丰收',
        className: 'yellow',
        color: themeColor.yellowTheme
      }, {
        name: '阳橙',
        className: 'orange',
        color: themeColor.orangeTheme
      }, {
        name: '热情',
        className: 'red',
        color: themeColor.redTheme
      }]
    };
  },
  computed: {
    defaultThemeClass: function defaultThemeClass() {
      return this.$store.state.settings.themeClass;
    },
    tagsView: {
      get: function get() {
        return this.$store.state.settings.tagsView;
      },
      set: function set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "tagsView",
          value: val
        });
      }
    },
    tagsIcon: {
      get: function get() {
        return this.$store.state.settings.tagsIcon;
      },
      set: function set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "tagsIcon",
          value: val
        });
      }
    },
    showLanguage: {
      get: function get() {
        return this.$store.state.settings.showLanguage;
      },
      set: function set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "showLanguage",
          value: val
        });
      }
    },
    showSearch: {
      get: function get() {
        return this.$store.state.settings.showSearch;
      },
      set: function set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "showSearch",
          value: val
        });
      }
    },
    useCache: {
      get: function get() {
        return this.$store.state.settings.useCache;
      },
      set: function set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "useCache",
          value: val
        });
      }
    },
    slideClass: {
      get: function get() {
        return this.$store.state.settings.slideClass;
      },
      set: function set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "slideClass",
          value: val
        });
      }
    },
    layoutType: {
      get: function get() {
        return this.$store.state.settings.layoutType;
      },
      set: function set(val) {
        UpdateTheme({
          theme: val
        }).then(function (res) {});
        this.$store.dispatch("settings/changeSetting", {
          key: "layoutType",
          value: val
        });
      }
    }
  },
  watch: {
    defaultThemeClass: {
      handler: function handler(val, oldVal) {
        if (!val) return;
        this.themeClass = val;
        var activeItem = this.imgUrl3.filter(function (o) {
          return o.className === val;
        })[0];
        this.theme = activeItem && activeItem.color ? activeItem.color : "#1890ff";
      },
      immediate: true
    }
  },
  created: function created() {},
  methods: {
    init: function init() {
      this.drawer = true;
    },
    checkList: function checkList(item) {
      if (item.layoutType === this.layoutType) return;
      this.layoutType = item.layoutType;
    },
    checkList2: function checkList2(item) {
      if (item.className === this.slideClass) return;
      this.slideClass = item.className;
    },
    checkList3: function checkList3(item) {
      if (item.className === this.themeClass) return;
      this.$store.dispatch("settings/changeSetting", {
        key: "themeClass",
        value: item.className
      });
    }
  }
};